import { styled } from '@mui/system'

export const SubHeaderContainer = styled('div')`
    display: flex;
    gap: 24px;
    height: 290px;
    margin-bottom: 24px;
`
